import { __awaiter } from "tslib";
import { PublicKey } from "@solana/web3.js";
import resolve from "./resolve";
import profile from "./profile";
import mapping from "./mapping";
import { getWalletsForDid, getCivicPassesForDid, gatekeeperNetworks, } from "./passes";
const validateGatekeeperNetworks = (gatekeeperNetworkAddresses) => {
    gatekeeperNetworkAddresses.map((gkNetworkAddress) => {
        try {
            return new PublicKey(gkNetworkAddress);
        }
        catch (_a) {
            throw new Error(`Invalid gatekeeper network address ${gkNetworkAddress}`);
        }
    });
};
const CivicProfile = {
    get: (query, options = {}) => __awaiter(void 0, void 0, void 0, function* () {
        const { document, address } = yield resolve.resolveRequestToDid(query, options);
        const publicProfile = yield profile.getPublicProfileForDidDocument(document);
        const mappedProfile = publicProfile
            ? mapping.mapPublicProfileResult(publicProfile)
            : {};
        const profileResult = Object.assign({ address, did: document.id }, mappedProfile);
        const getLinkedPublicKeys = () => __awaiter(void 0, void 0, void 0, function* () {
            return getWalletsForDid(document);
        });
        const getPasses = (queryGatekeeperNetworks = Object.keys(gatekeeperNetworks)) => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            if (!((_a = options === null || options === void 0 ? void 0 : options.solana) === null || _a === void 0 ? void 0 : _a.connection)) {
                throw new Error("No solana connection in CivicProfile when trying to get passes");
            }
            validateGatekeeperNetworks(queryGatekeeperNetworks);
            return getCivicPassesForDid(document, (_b = options.solana) === null || _b === void 0 ? void 0 : _b.connection, queryGatekeeperNetworks);
        });
        return Object.assign({ getLinkedPublicKeys,
            getPasses }, profileResult);
    }),
};
export default CivicProfile;
